import { useSortingParamsToggle, SortingDirection } from '@occc-app/hooks/useSortingParams';
import { Retailer_Network_Performance_Sort_By } from '@occc/graphql';

import { LocationGroupSort } from './retailer-network-location-group-details-page.types';
import {
  LOCATIONS_AFTER_PARAM,
  LOCATIONS_BEFORE_PARAM,
} from '../retailer-network-locations-configuration/retailer-network-locations-configuration.constants';

import {
  getRetailerNetworkPerformanceSortBy,
  mapSortDirectionRetailerNetworkPerformanceSortOrder,
} from '../retailer-connect.utils';

const DEFAULT_SORTING_DIRECTION: SortingDirection = 'desc';

export const useLocationGroupSorting = (): LocationGroupSort => {
  const [sortingValue, toggleSorting] = useSortingParamsToggle(
    {
      field: Retailer_Network_Performance_Sort_By.TotalNewMembers,
      direction: DEFAULT_SORTING_DIRECTION,
    },
    LOCATIONS_BEFORE_PARAM,
    LOCATIONS_AFTER_PARAM,
  );

  const field = getRetailerNetworkPerformanceSortBy(sortingValue?.field);
  const direction =
    mapSortDirectionRetailerNetworkPerformanceSortOrder[
      sortingValue?.direction || DEFAULT_SORTING_DIRECTION
    ];

  return [{ direction, field }, toggleSorting];
};
